import React from 'react'
import moment from 'moment-timezone'
import { Progress } from 'reactstrap';
import {makeStyles} from '@material-ui/core'
import { isUndefined } from 'lodash'

const useStyles = makeStyles({
  MainProgress: {
    height:"100% !important",
    borderRadius:"0"
  }
});

export default function CountDownComponent(props) {
  const classes = useStyles()

  const [time, setTime] = React.useState('00:00:00')
  const [progress, setProgress] = React.useState(0)

  const setTimeFunc = () => {
    let diff = moment(props.countEnd).diff(moment())
    let hasStarted = moment().diff(props.countStart) > 0
    if(!hasStarted) diff = moment(props.countEnd).diff(moment(props.countStart))

    if(hasStarted) {
      let diff2 = moment(props.countEnd).diff(moment(props.countStart))
      console.log(100 - ((diff / diff2) * 100))
      setProgress(100 - ((diff / diff2) * 100))
    }

    let duration = moment.duration(diff, 'millisecond')
    console.log(duration)

    let hours = duration.hours().toString()
    hours = hours.length <= 1 ? '0'+hours : hours

    let minutes = duration.minutes().toString()
    minutes = minutes.length <= 1 ? '0'+minutes : minutes

    let seconds = duration.seconds().toString()
     seconds = seconds.length <= 1 ? '0'+seconds : seconds

    let days = duration.days()
    days = days <= 0 ? '' : `${days}:`

    if(diff > 0) setTime(`${days}${hours}:${minutes}:${seconds}`)
  }

  React.useEffect(() => {
    setTimeFunc()
    let interval = null;
    interval = setInterval(() => {
      setTimeFunc()
    }, 1000);
    
    return () => clearInterval(interval);
  },[props])

  return (
    <>
    {/*<div className='position-absolute h-100 w-100' style={{zIndex: -1}}>
      <Progress multi className={classes.MainProgress} style={{backgroundColor: `${isUndefined(props.BackGroudColor)?"#fff":props.BackGroudColor} !important`,}}>
        <Progress bar animated 
          color={"#4bc3c5"}
          value={progress} 
          max={100}
        >
        </Progress>
      </Progress>
    </div>*/}
    <div className='d-flex align-items-center justify-content-center h-100 w-100'>
       
      <h1 className='m-0' style={{
        color: isUndefined(props.FontColor)?"#fff":`${props.FontColor}`,
        fontSize: isUndefined(props.textSize) ? 50 : props.textSize, fontWeight: 700}}>{time}</h1>
    </div>
    </>
  )
}
